import { QueryClient } from 'react-query';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental';
import { env } from './configs/EnvironmentConfig';

const localStoragePersistor = createWebStoragePersistor({ storage: window.localStorage });

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchOnWindowFocus: true,
    },
  },
});

persistQueryClient({
  queryClient,
  persistor: localStoragePersistor,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours,
  buster: env.REACT_APP_BUILD_NUMBER ?? '',
});

export const resetCache = () => {
  queryClient.clear();
};
